import Empty from '@/views/Empty';
import EmployeeIndex from '@/views/pages/employee/Index';

import EmployeeDetail from '@/views/pages/employee/Detail';
import EmployeeDetailIndex from '@/views/pages/employee/detail/Index';
import EmployeeActivity from '@/views/pages/employee/detail/Activity';

export default {
  path: 'employees',
  component: Empty,
  children: [
    {
      path: '',
      name: 'Employee',
      component: EmployeeIndex,
    },
    {
      path: ':employeeId',
      component: EmployeeDetail,
      children: [
        {
          path: '',
          name: 'Employee Detail',
          component: EmployeeDetailIndex,
        },
        {
          path: 'activity',
          name: 'Employee Activity',
          component: EmployeeActivity,
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/employee.js